/**
 * Configuration centrale du site Solution Éco France.
 * Source unique pour l'URL canonique, le branding et les métadonnées SEO globales.
 */
export const SITE = {
  /** URL canonique en production (sans slash final). */
  url: 'https://solutionecofrance.fr',
  /** Nom officiel de la marque (avec É accentué). */
  name: 'Solution Éco France',
  /** Slogan court pour OG/Twitter description fallback. */
  tagline:
    "On vous aide à payer moins d'énergie et à financer vos travaux. Diagnostic gratuit, réponse chiffrée, aucun frais caché.",
  /** Locale principale (BCP 47). */
  locale: 'fr-FR',
  /** Image Open Graph par défaut (1200×630). */
  ogImage: '/og-default.jpg',
  /** Compte Twitter / X officiel (sans @). */
  twitter: 'SolutionEcoFR',
  /** Couleur de marque pour <meta theme-color>. */
  themeColor: '#10b981',
  /** Email de contact principal (utilisé dans certains JSON-LD). */
  contactEmail: 'contact@solutionecofrance.fr',
} as const;

/**
 * Construit une URL absolue à partir d'un chemin relatif.
 * Garantit l'absence de doubles slashs et la présence du scheme.
 */
export function absoluteUrl(path = '/'): string {
  if (path.startsWith('http://') || path.startsWith('https://')) return path;
  const cleanPath = path.startsWith('/') ? path : `/${path}`;
  return `${SITE.url}${cleanPath}`;
}
